import { gql } from '@apollo/client';

export const getLocalidadesSuc = gql`
query localidadSucApi{
    localidadesSuc(idPartido:$idPartido)  
    @rest(type: "Localidad", path: "/gateway/sucursales/location/district/{args.idPartido}"){
        id_localidad
        desc_localidad
    }
}
`   